import React, { FunctionComponent } from 'react'

import styled, { useTheme } from 'styled-components/native'

import { BodyText } from '../../atoms/bodyText/BodyText'
import { Title } from '../../atoms/title/Title'
import { AssignmentIconSelector } from '../../organisms/assignmentsList/AssignmentIconSelector'
import { BodyTextSize, TitleSize } from '../../styles/typeStyles'
import { ThemeType } from '../../utils/themes/ThemeProvider'

export type FormContentHeaderProps = {
  title?: string
  dateDisplay?: string
  group?: string
}

const FormContentHeaderContainer = styled.View<{ theme: ThemeType }>(({ theme }) => ({
  marginHorizontal: theme.spacing['16px'],
}))

const TitleContainer = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
})

const IconContainer = styled(BodyText)({
  height: '24px',
  marginRight: '10px',
})

const TitleTextContainer = styled(Title)<{ theme: ThemeType }>(({ theme: { colors } }) => ({
  fontWeight: 700,
  color: colors.textPrimary,
}))

export const FormContentHeader: FunctionComponent<FormContentHeaderProps> = ({ title, dateDisplay, group }) => {
  const { colors } = useTheme()

  return (
    <FormContentHeaderContainer>
      <TitleContainer>
        <IconContainer>
          <AssignmentIconSelector type={group} size={24} />
        </IconContainer>
        <TitleTextContainer text={title} size={TitleSize.MEDIUM} />
      </TitleContainer>
      <BodyText text={dateDisplay} size={BodyTextSize.DEFAULT} color={colors.textPrimary} />
    </FormContentHeaderContainer>
  )
}
